import React, { useState } from 'react';
import { ColorPicker } from 'primereact/colorpicker';
import './colorPicker.css.js';

const C2Picker = (props) => {
    const [color, setColor] = useState();
    return React.createElement("div", { className: "w-full border-1 p-2 border-round-sm surface-border" },
        React.createElement(ColorPicker, { className: "border-circle", value: color, onChange: (e) => setColor(e.value) }),
        "#",
        color);
};

export { C2Picker as default };
//# sourceMappingURL=ColorPicker.js.map
